import GradientBorderRadius from "./gradient-border-radius";
import { IconComponent } from "./icon";
import { IconsTypes } from "./icon";
import { ComponentPropsWithoutRef, FC } from "react";

import GradientBackground from "./gradient-background";
import clsx from "clsx";

const IconButton: FC<
  ComponentPropsWithoutRef<"button"> & {
    name: IconsTypes;
    variant?: "circle" | "smaller";
    enabled?: boolean;
    className?: string;
    withBorder?: boolean;
    withHover?: boolean;
    iconClassName?: string;
    iconProps?: object;
  }
> = ({
  name = "check",
  variant = "circle",
  enabled = false,
  className = "",
  withBorder = true,
  withHover = false,
  iconClassName = "",
  iconProps = {},
  ...rest
}) => {
  if (withBorder) {
    return (
      <button {...rest}>
        <GradientBorderRadius
          radius={variant}
          gradient="default-border"
          hover="r-100"
          active={enabled ? "r-100" : undefined}
        >
          <div className={clsx("flex justify-center items-center", className)}>
            <IconComponent
              name={name}
              className={iconClassName}
              {...iconProps}
            />
          </div>
        </GradientBorderRadius>
      </button>
    );
  }

  if (withHover) {
    return (
      <button {...rest}>
        <GradientBorderRadius
          radius={variant}
          gradient="none"
          hover="r-100"
          active={enabled ? "r-100" : undefined}
        >
          <div className={clsx("flex justify-center items-center", className)}>
            <IconComponent
              name={name}
              className={iconClassName}
              {...iconProps}
            />
          </div>
        </GradientBorderRadius>
      </button>
    );
  }

  return (
    <button {...rest}>
      <GradientBackground
        enabled={enabled}
        className={clsx(
          variant === "smaller" && "rounded-[0.1875rem]",
          variant === "circle" && "rounded-full",
          className
        )}
        hover={true}
      >
        <div className={clsx("h-full w-full flex justify-center items-center")}>
          <IconComponent name={name} className={iconClassName} {...iconProps} />
        </div>
      </GradientBackground>
    </button>
  );
};

export default IconButton;
